module.exports = __webpack_public_path__ + "img/Alley-Foliage.105965de.jpg";